<script setup>
import { useAuthStore } from '@lib/pp-shop-lib/stores';
import { computed } from 'vue';

// redirect home if already logged in
const authStore = useAuthStore();
const accountViewKey = computed(() => {
    return authStore.user?.kid || authStore.user?.username || authStore.user?.email || 'guest'
})
/* if (authStore.user) {
    router.push('/');
} */
</script>

<template>
    <div class="uk-container uk-container-small">
        <router-view :key="accountViewKey" />
    </div>
</template>
